import { Button, FormControl, Icon, TextField, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import "../chatbot.css";
import React, { Component, Fragment } from "react";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  button: {
    margin: theme.spacing(1),
  },
}));

export default function CifDateofBirthForm(props) {
  const classes = useStyles();
  /**
   * NOTE ON DATE
   * 1. en-GB => British English uses day-month-year order
   *    → "20/12/2012"
   * 2. en-US => US English uses month-day-year order
   *    → "12/19/2012"
   */
  const [selectedDate, setSelectedDate] = React.useState(new Date());
  const [enteredCifNumber, setEnteredCifNumber] = React.useState();

  const handleDateChange = (date) => {
    console.log("handleDateChange Called");
    setSelectedDate(date);
    console.log("Date Change: ", date);
    console.log("today.toLocaleDateString", date.toLocaleDateString("en-GB"));
  };

  const handleCifNumber = (e) => {
    console.log(e.target.value);
    setEnteredCifNumber(e.target.value);
  }

  // const sendDate = (e) => {
  //   console.log("date from send Date: ", selectedDate);
  //   console.log(
  //     "date after change: ",
  //     selectedDate.toLocaleDateString("en-GB").replace(/\//g, "")
  //   );
  // };

  return (
    <Fragment>
      <div className="msg-content-wrapper message-content-wrapper-bot msg-content-wrapper-border width-70">
        <Grid item xs>
          <Typography
            gutterBottom
            variant="button"
            align="center"
            component="subtitle2"
            display="block"
          >
            {/* Date of Birth Header */}
            <h5 className="date_of_birth_card_header">
              Enter Your Date of Birth
            </h5>
          </Typography>
        </Grid>
        {/* Cif Number */}
        <FormControl>
        <TextField value={enteredCifNumber} id="outlined-basic" label="Cif Number" variant="outlined" onChange={handleCifNumber} />
        </FormControl>
        <br></br>
        {/* Date Picker Component */}
        <FormControl>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justifyContent="space-around">
              <KeyboardDatePicker
                autoOk
                variant="inline"
                inputVariant="outlined"
                label="Date of Birth"
                format="dd/MM/yyyy"
                value={selectedDate}
                InputAdornmentProps={{ position: "start" }}
                onChange={(date) => handleDateChange(date)}
              />
            </Grid>
          </MuiPickersUtilsProvider>
        </FormControl>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          endIcon={<Icon>send</Icon>}
          onClick={(e) => {
            // console.log("selectedDate: ", selectedDate);
            if (selectedDate != "invalid date") {
              // props.onSendWorkflowDateOfBirth(
              //   selectedDate.toLocaleDateString("en-GB").replace(/\//g, "")
              // );
              console.log({
                cif_number: enteredCifNumber,
                date: selectedDate.toLocaleDateString("en-GB").replace(/\//g, "")
              });
              props.onSendWorkflowCifDateOfBirth({
                cif_number: enteredCifNumber,
                date: selectedDate.toLocaleDateString("en-GB").replace(/\//g, "")
              })
            }
          }}
        >
          Send
        </Button>
      </div>
    </Fragment>
  );
}
